import styled from "styled-components";

export const CookieConfirmationWrapper = styled.div`
  position: fixed;
  bottom: 60px;
  left: 50%;
  transform: translate(-50%, 0);
  z-index: 999998;
  background: ${({ refreshapp }) =>
    refreshapp ? "var(--cookieConfirmationRefreshBg)" : "var(--cookiesbg)"};
  border-radius: ${({ refreshapp }) =>
    refreshapp
      ? "var(--cookieConfirmationRefreshBorderRadius)"
      : "var(--cookieConfirmationBorderRadius)"};
  display: ${({ hidden }) => (hidden ? "none" : "")};
  box-shadow: 0 0 0 1px var(--cookiesbg);

  @media (max-width: 967px) {
    width: 255px;
  }
`;

export const CookieConfirmationDialog = styled.div`
  padding: 0px;
  display: inline;
`;

export const CookieMessage = styled.div`
  padding: 0 0 0 20px;
  float: left;
  font-size: 12px;
  color: var(--cookieReverseColor);
  line-height: 45px;
  font-weight: 600;

  a {
    color: var(--cookieLinkColor, var(--labelcolordark));
    text-decoration: underline;
    font-weight: 600;
  }
  @-moz-document url-prefix() {
    font-size: 10px !important;
  }
`;

export const CookieButtons = styled.div`
  display: table;
  float: right;
  height: 100%;
  padding: 0 20px 0 0;

  button {
    height: 100%;
    padding: 0px;
    margin-left: 15px;
    border: none;
    font-weight: 800;
    text-transform: uppercase;
    line-height: 45px;
    font-size: 12px;
    color: var(--cookieReverseColor);
    background-color: transparent;
    cursor: pointer;
    :hover {
      color: var(--cookieConfirmationButtonHoverColor);
    }
  }
`;
